export default "__VITE_ASSET__0kIBE9xP__"